export function getNumberFormatPartValue(part) {
    return part ? part.value : "";
}
//# sourceMappingURL=getNumberFormatPartValue.js.map